// @flow
import type {HttpService} from 'modules/common/services/http';

/**
 * Сервис для отправки\загрузки информации по модалкам и другим общим компонентам
 */
export class CommonApi {
    /**
     * Сервис для отправки HTTP запросов
     */
    _http: HttpService;

    /**
     * @param http Сервис для отправки HTTP запросов
     */
    constructor(http: HttpService) {
        this._http = http;
    }
}
